import produce, { Draft } from 'immer';

import { ISetAccounts, ISetAccountsFetching } from '../../actions/accounts';
import * as actionTypes from '../../constants/actionTypes';
import { DomainAccountWithDomain } from '../../meta/types/user';

export const initialState = Object.freeze({
  accounts: [] as DomainAccountWithDomain[],
  fetched: false,
  fetching: false,
});

export type AccountState = typeof initialState;

const account = (
  state: AccountState = initialState,
  action: ISetAccounts | ISetAccountsFetching,
) => {
  return produce<AccountState>(state, (draft: Draft<AccountState>) => {
    switch (action.type) {
      case actionTypes.SET_ACCOUNTS:
        draft.fetched = true;
        draft.fetching = false;
        draft.accounts = action.accounts;
        return;
      case actionTypes.SET_ACCOUNTS_FETCHING:
        draft.fetching = true;
        return;
      default:
        return;
    }
  });
};

export default account;
